/* eslint-disable prefer-const */

import React, { memo, useEffect, useMemo } from "react";

import { useFormContext } from "react-hook-form";

import { Box } from "@origin-digital/ods-core";
import { task } from "@origin-digital/reporting-client";

import { StyledHeading, StyledText } from "@/components";
import { ANALYTICS_FORM_NAME, ANALYTICS_TASK_TYPE } from "@/constants";

import { hardStop } from "./content.json";
import { switchWording } from "./utils/switchWording";

export const HardStopScreen = memo(() => {
  const { getValues } = useFormContext();

  const customerType = getValues("customerType");
  const useBuildingWord = true;

  const getHardStopText = useMemo(() => {
    const hardStopName = getValues("hardStop");

    let content = hardStop[hardStopName];

    if (!content) {
      content = hardStop["default"];
    }

    let { heading, description: desc } = content;

    if (hardStopName === "roofMaterial") {
      const roofMaterial = getValues("roofMaterial");
      desc = desc.replace("[roof material]", roofMaterial);
    }

    return {
      heading,
      desc,
    };
  }, [getValues]);

  useEffect(() => {
    task.base(ANALYTICS_TASK_TYPE, {
      action: "fallout",
      formName: ANALYTICS_FORM_NAME,
    });
  }, []);

  return (
    <>
      <Box width="full">
        <StyledHeading>
          {switchWording(
            getHardStopText.heading,
            customerType,
            useBuildingWord
          )}
        </StyledHeading>
        <StyledText>
          {switchWording(getHardStopText.desc, customerType, useBuildingWord)}
        </StyledText>
      </Box>
    </>
  );
});
